import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2035fbd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Aanpasbare indelingen", -1))
const _hoisted_2 = { style: {"font-weight":"600"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "completion1-option-image" }
const _hoisted_5 = ["src", "height"]
const _hoisted_6 = { class: "completion1-option-details" }
const _hoisted_7 = { class: "completion1-option-header" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "completion1-option-content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "completion1-option-footer" }
const _hoisted_12 = { class: "completion1-option-actions" }
const _hoisted_13 = { class: "completion1-option-price" }
const _hoisted_14 = { class: "no-mb" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"400"} }, "incl. 21% BTW", -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Layout", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1))
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Afbeelding", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = ["src"]

import { onMounted, ref } from 'vue'
import { completionOneStore } from '@/stores/completionOne'
import { CheckOutlined, DownOutlined, LoadingOutlined, WarningTwoTone } from '@ant-design/icons-vue'
import { generalStore } from '../../stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion1OptionsGrid',
  setup(__props) {

onMounted(() => {
  completionOneStore().getRooms()
})

const showLayoutDetailsModal = ref(false)
const currentLayout = ref<{ id:number, externalRef:string, name:string, textSales:string, img:{ url:string }|null }|null>(null)

function checkIfBottomBorder (layoutCount:number, layoutIndex:number) : string {
  const itemsOnBottomRow = layoutCount % 4

  if (layoutCount <= 4) {
    return 'no-border-bottom'
  } else if (layoutIndex > (layoutCount - itemsOnBottomRow)) {
    return 'no-border-bottom'
  }

  return ''
}

function toggleLayoutDetailsModal (layout:{ id:number, externalRef:string, name:string, textSales:string, img:{ url:string }|null }|null = null) : void {
  showLayoutDetailsModal.value = !showLayoutDetailsModal.value
  currentLayout.value = layout
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_unref(completionOneStore)().rooms.length && !_unref(completionOneStore)().loading.rooms)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(completionOneStore)().rooms, (room, roomIndex) => {
          return (_openBlock(), _createBlock(_component_a_collapse, {
            class: "completion1-collapse",
            key: room.id
          }, {
            expandIcon: _withCtx(({ isActive }) => [
              (room.selected_layout && room.selected_layout.id)
                ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                    key: 0,
                    style: {"color":"green"}
                  }))
                : (_openBlock(), _createBlock(_unref(DownOutlined), {
                    key: 1,
                    rotate: isActive ? 180 : 0
                  }, null, 8, ["rotate"]))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, {
                class: _normalizeClass(room.selected_layout && room.selected_layout.id ? 'panel-no-padding completed' : 'panel-no-padding incomplete')
              }, {
                header: _withCtx(() => [
                  _createElementVNode("b", _hoisted_2, _toDisplayString(room.level) + "." + _toDisplayString(room.position) + " - " + _toDisplayString(room.name), 1)
                ]),
                extra: _withCtx(() => [
                  (_unref(completionOneStore)().loading.layouts.includes(room.id))
                    ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                        key: 0,
                        style: {"color":"#f38929"}
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(room.selected_layout && room.selected_layout.id && _unref(generalStore)().desktop ? 'Gekozen: ' + room.selected_layout.name : ''), 1))
                ]),
                default: _withCtx(() => [
                  (room.layouts && room.layouts.length && !_unref(completionOneStore)().loading.layouts.includes(room.id))
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 0,
                        style: {"margin-bottom":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, { style: {"margin-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.layouts, (layout, layoutIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass((_unref(generalStore)().desktop ? 'completion1-option-grid-item ' : 'completion1-option-grid-item-mobile ') + checkIfBottomBorder(room.layouts.length, layoutIndex + 1)),
                                      key: layout.id
                                    }, [
                                      _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", null, [
                                          (layout.default)
                                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 0,
                                                color: "#f38929",
                                                style: _normalizeStyle(_unref(generalStore)().desktop ? { position: 'absolute', margin: '150px 0 0 8px' } : { position: 'absolute', margin: '70px 0 0 8px' })
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Standaard")
                                                ]),
                                                _: 1
                                              }, 8, ["style"]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("img", {
                                            src: layout.img ? layout.img.url : '/img/No_Image.png',
                                            height: _unref(generalStore)().desktop ? 180 : 100
                                          }, null, 8, _hoisted_5)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                          _createElementVNode("p", null, [
                                            _createTextVNode(_toDisplayString(layout.name) + " ", 1),
                                            (layout.excluded_from_warranty)
                                              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                  title: _withCtx(() => [
                                                    _createTextVNode("Deze indeling is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(WarningTwoTone), {
                                                      "two-tone-color": "#f38929",
                                                      style: {"margin-left":"4px"}
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("p", _hoisted_8, "Optie nr. " + _toDisplayString(layout.externalRef), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                          _createElementVNode("p", {
                                            style: {"color":"#f38929","cursor":"pointer"},
                                            onClick: ($event: any) => (toggleLayoutDetailsModal(layout))
                                          }, "Meer informatie", 8, _hoisted_10)
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                          _createElementVNode("div", _hoisted_12, [
                                            (room.selected_layout && room.selected_layout.id === layout.id)
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 0,
                                                  type: "primary",
                                                  class: "option-btn",
                                                  disabled: _unref(completionOneStore)().saving.roomId === room.id || _unref(completionOneStore)().phaseIsClosed
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Gekozen")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled"]))
                                              : (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 1,
                                                  loading: _unref(completionOneStore)().saving.roomId === room.id && _unref(completionOneStore)().saving.layoutId === layout.id,
                                                  disabled: _unref(completionOneStore)().saving.roomId === room.id || _unref(completionOneStore)().phaseIsClosed,
                                                  onClick: ($event: any) => (_unref(completionOneStore)().selectLayout(room, roomIndex, layout))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(!_unref(completionOneStore)().phaseIsClosed ? 'Kies' : 'Niet gekozen'), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "disabled", "onClick"]))
                                          ]),
                                          _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("p", _hoisted_14, "€ " + _toDisplayString(layout.price), 1),
                                            _hoisted_15
                                          ])
                                        ])
                                      ])
                                    ], 2))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_a_skeleton, {
                        key: 1,
                        style: {"padding":"16px"},
                        active: ""
                      }))
                ]),
                _: 2
              }, 1032, ["class"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      : (_unref(completionOneStore)().loading.rooms)
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 1,
            active: ""
          }))
        : (_openBlock(), _createElementBlock("b", _hoisted_16, "Er zijn geen aanpasbare indelingen voor dit bouwnummer beschikbaar. U kunt verder gaan naar Afbouw 2.")),
    (currentLayout.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 3,
          width: 600,
          footer: false,
          visible: showLayoutDetailsModal.value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (toggleLayoutDetailsModal()))
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentLayout.value.externalRef) + " - " + _toDisplayString(currentLayout.value.name), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(currentLayout.value.externalRef) + " - " + _toDisplayString(currentLayout.value.name) + " ", 1),
                      (currentLayout.value.excluded_from_warranty)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                            title: _withCtx(() => [
                              _createTextVNode("Deze indeling is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(WarningTwoTone), {
                                "two-tone-color": "#f38929",
                                style: {"margin-left":"4px"}
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (currentLayout.value.textSales)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _createElementVNode("div", {
                          innerHTML: currentLayout.value.textSales
                        }, null, 8, _hoisted_19)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (currentLayout.value.img)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("img", {
                          src: currentLayout.value.img.url,
                          style: {"width":"100%"}
                        }, null, 8, _hoisted_22)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})